import AddIcon from "@mui/icons-material/Add";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { useContext, useEffect, useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import { EDialogAction } from "../Components/Enum/DialogActionEnum";
import CountryTemplateTable from "../Components/CountryTemplate/CountryTemplateTable";
import axiosInstance from "../utilities/Axios";
import CountryTemplateDialogBox from "../Components/CountryTemplate/CountryTemplateDialogBox";
import useQuery from "../Hooks/useQueryHook/useQueryHook";
import { Subject, debounceTime } from "rxjs";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../Hooks/ThemeContext/ThemeContext";
import { useSnackbar } from "notistack";
import { Button } from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import React from "react";
import { LoadingStateContext } from "../Hooks/LoadingContext/LoadingContext";
import Scaffold from "../Components/Layout/Scaffold";

const CountryTemplate = (props: { open: boolean; onClose: any; data: any }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const limit = 10;
  const query = useQuery();
  const [countryProcessList, setCountryProcessList] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [countryProcessId, setCountryProcessId] = useState<any>("");
  let [filter, setfilter] = useState<any>({});
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [countryTemplateList, setCountryTemplateList] = useState<any[]>([]);
  const [textInput, setTextInput] = useState("");
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [debouncedFilter, setDebouncedFilter] = useState<any>({});
  const { changeLoading, isLoading } = useContext(LoadingStateContext);

  const default_templates = [
    {
      order: 100,
      country_process_id: +countryProcessId,
      title: "med",
      type: "PDF",
      image_url: "",
    },
    {
      order: 101,
      country_process_id: +countryProcessId,
      title: "visa",
      type: "PDF",
      image_url: "",
    },
    {
      order: 102,
      country_process_id: +countryProcessId,
      title: "at",
      type: "PDF",
      image_url: "",
    },
    {
      order: 103,
      country_process_id: +countryProcessId,
      title: "passport",
      type: "PDF",
      image_url: "",
    }
  ];

  const [values] = useState(() => new Subject());
  useEffect(() => {
    const sub = values.pipe(debounceTime(2000)).subscribe(() => {
      setDebouncedFilter(filter);
    });
    return () => sub.unsubscribe();
  }, [filter]);

  useEffect(() => {
    getCountryProcessList();
    //getCountryTemplateList(countryProcessId);
  }, [filter]);

  useEffect(() => {
    const countryProcessId = query.get("countryProcessId");
    changeFilters("country_process_id", countryProcessId);
    setCountryProcessId(countryProcessId);
  }, []);

  const handleTextInputChange = (event: any) => {
    setTextInput(event.target.value);
  };

  function changeFilters(key: string, value: any) {
    setfilter((oldState: any) => {
      return { ...oldState, [key]: value };
    });
  }

  function onDropdownChange(key: string, value: any) {
    navigate(`?countryProcessId=${value}`);
    changeFilters(key, value);
    setCountryProcessId(value);
  }

  function clearSearch() {
    setTextInput("");
    changeFilters("keyword", "");
  }

  function editDialogClose() {
    setEditDialogVisibility(false);
    changeFilters("timestamp", "" + Date.now());
  }
  const handleClose = (action: string = "closed") => {
    props.onClose(action);
  };
  const getCountryTemplateList = async (countryProcess: number) => {
    changeLoading(true)
    try {
      const response = await axiosInstance.get(`/v1/country-process-tpl`, {
        params: {
          country_process_id:  query.get("countryProcessId"),
        },
      });

      const data = response.data;
      setCountryTemplateList(data.result);

    } catch (err) {
      console.log(err);
    } finally {
      changeLoading(false)
    }
  };

  const createDefaultCountryTemplate = async () => {
    // getCountryTemplateList(countryProcess);
    const orderIdsToCheck = ["100", "101", "102"];
    const ordersExist = countryTemplateList.some((template) =>
      orderIdsToCheck.includes(template.order)
    );
    try {
      if (!ordersExist) {
        const url = `${process.env.REACT_APP_API_ORIGIN}/v1/country-process-tpl`;
        const axiosPromises = default_templates.map(async (template) => {
          const res = await axiosInstance.post(url, template);
          enqueueSnackbar("Country Process Template Created Successfully!!!!", {
            variant: "success",
          });

          
        });
        await Promise.all(axiosPromises);
        changeFilters("country_process_id", countryProcessId);
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar("Failed to Create Country Process Template!!!!", {
        variant: "error",
      });
    }
  };
  const getCountryProcessList = async () => {
    changeLoading(true);
    try {
      const response = await axiosInstance.get(
        `/v1/country-process?type=${theme.theme}&page=${page}&items_per_page=${limit}`
      );

      const data = response.data;
      setCountryProcessList(data.result.data);

      setTotalItems(data.result.length);

    } catch (err) {
      console.log(err);
    } finally {
      changeLoading(false);
    }
  };

  return (
    <Scaffold
      title="Country Templates"
      mainAction={<>
        {filter["country_process_id"] && <div className="flex md:w-full md:justify-end ">
          <Button variant="contained"
            color="primary"
            size="small"
            className="mx-2"
            onClick={() => {
              createDefaultCountryTemplate();
            }}
            startIcon={<AddIcon fontSize="small" />}
          >
            Create Deafult Template
          </Button>
          <Button variant="contained"
            color="primary"
            size="small"
            onClick={() => {
              setEditDialogVisibility(true);
            }}
            startIcon={<AddIcon fontSize="small" />}
          >Create</Button>
        </div>}
      </>}
      actions={[
        <Box
          component="form"
          sx={{
            "& .MuiTextField-root": {
              maxwidth: "75ch",
            },
          }}
          noValidate
          autoComplete="off"
        >
          <FormControl size="small" sx={{ minWidth: 200 }}>
            <InputLabel id="demo-simple-select-label">
              Country Process
            </InputLabel>
            <Select
              size="small"
              labelId="demo-simple-select-label"
              id="demo-simple-select-standard"
              label="Country Process"
              value={filter["country_process_id"] || ""}
              onChange={(event) => {
                onDropdownChange("country_process_id", event.target.value);
              }}
            >
              {countryProcessList.map((data: any, key: number) => {
                return (
                  <MenuItem value={data.id} key={data.id}>
                    <em>
                      {data.id} - {data.country_name}
                    </em>
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Box>
      ]}
    >
      <div>
        <CountryTemplateTable filter={filter} key={filter} />

        <CountryTemplateDialogBox
          open={editDialogVisibility}
          onClose={editDialogClose}
          countryProcessId={filter["country_process_id"]}
          key={filter["country_process_id"]}
          data={{}}
          dialogAction={EDialogAction.create}
        />
      </div>
    </Scaffold>
  )


  // old code is below
  return (
    <>
      <p className="text-2xl mb-3 ">Country Templates</p>
      <div className="flex flex-col md:flex-row">
        <div className="flex">
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": {
                maxwidth: "75ch",
              },
            }}
            noValidate
            autoComplete="off"
          >
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel id="demo-simple-select-label">
                Country Process
              </InputLabel>
              <Select
                // sx={{
                //   width: 200,
                //   height: 30,
                //   marginTop: "5px",
                //   borderRadius: "10px",
                //   fontSize: "8px",
                // }}
                size="small"
                labelId="demo-simple-select-label"
                id="demo-simple-select-standard"
                label="Country Process"
                value={filter["country_process_id"] || ""}
                onChange={(event) => {
                  onDropdownChange("country_process_id", event.target.value);
                }}
              >
                {countryProcessList.map((data: any, key: number) => {
                  return (
                    <MenuItem value={data.id} key={data.id}>
                      <em>
                        {data.id} - {data.country_name}
                      </em>
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Box>
          <Button
            className="mx-2"
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => {
              changeFilters("keyword", "" + textInput);
            }}>
            Search
          </Button>
        </div>
        {filter["country_process_id"] && <div className="flex md:w-full md:justify-end ">
          <Button variant="contained"
            color="primary"
            size="small"
            className="mx-2"
            onClick={() => {
              createDefaultCountryTemplate();
            }}
            startIcon={<AddIcon fontSize="small" />}
          >
            Create Deafult Template
          </Button>
          <Button variant="contained"
            color="primary"
            size="small"
            onClick={() => {
              setEditDialogVisibility(true);
            }}
            startIcon={<AddIcon fontSize="small" />}
          >Create</Button>
        </div>}
      </div>


      <div>
        <CountryTemplateTable filter={filter} key={filter} />
      </div>
      <div>
        <CountryTemplateDialogBox
          open={editDialogVisibility}
          onClose={editDialogClose}
          countryProcessId={filter["country_process_id"]}
          key={filter["country_process_id"]}
          data={{}}
          dialogAction={EDialogAction.create}
        />
      </div>
    </>
  );
};

export default CountryTemplate;
